import $ from 'jquery';

(($, Drupal, once) => {
Drupal.behaviors.furuboda_sidemenu = {
  attach: function() {
    $('.side-menu')
      // .once('side-menu')
      .each((index, element) => this.showLimitedSideMenu(element));
  },

  showLimitedSideMenu(element) {
    $(window).on("load",function(){
      const sideMenu = document.getElementsByClassName('side-menu');
      const allPrimaryMenus = document.querySelectorAll('li.menu-item__level-0');
      const activePage = sideMenu[0].getElementsByClassName('is-active');
      const currentMenu = activePage[0].closest('li.menu-item__level-0');
      const parentUl = activePage[0].closest('ul');

      allPrimaryMenus.forEach(menu => {
        if (menu === currentMenu) {
          menu.classList.remove("not-current");
        }

        if (menu !== currentMenu) {
          menu.classList.add("not-current");
        }
      })

      if (parentUl.classList.contains('submenu')) {
        const parentMenu = parentUl.closest('li');
        const menuBtn = parentMenu.getElementsByTagName('button');
        menuBtn[0].classList.add('close-menu');
        parentUl.classList.toggle('expanded');
      }

      element.classList.remove("hide-sidemenu")
    });
  },
};
})(jQuery, Drupal, once);
